import './scss/app.scss'

//// MODULE IMPORTS

/// Swiper
// core styles
import 'swiper/css'

// module styles
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// js
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper'

Swiper.use([Autoplay, Navigation, Pagination])

/// GSAP
import {gsap, CSSPlugin, Expo, Linear} from 'gsap'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin, CSSPlugin, Expo, Linear)

/// imagesLoaded
import imagesLoaded from 'imagesloaded';

//// CODE BELOW

// Scroll to anchor
(function () {
    const trigger = document.querySelectorAll('[data-scroll-anchor]')

    function scrollToAnchor(e) {
        e.preventDefault()

        const target = document.querySelector(this.hash)
        const targetPos = target.offsetTop

        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: targetPos
            },
            ease: Expo.easeInOut
        })
    }

    trigger.forEach(el => el.addEventListener('click', scrollToAnchor, false))
})();

// Intro animation
(function () {

    function installMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
        var mql = window.matchMedia(mediaQuery);
        mql.addEventListener('change', function (e) {
            return layoutChangedCallback(e.matches);
        });
        layoutChangedCallback(mql.matches);
    }

    if (document.querySelector('.intro')) {
        const logo = document.querySelector('.navbar-brand');
        const navLinks = document.querySelectorAll('.navbar .nav-link');
        const intro = document.querySelectorAll('.intro');
        const introCurtainsBox = document.querySelectorAll('.intro-curtain');
        const introCurtains = document.querySelectorAll('.intro-curtain .curtain');
        const introBox = document.querySelector('.intro-container');
        const introLogoBox = document.querySelector('.intro-logo');
        const decorFront = document.querySelector('.section-hero .decor-front');
        const decorBack = document.querySelector('.section-hero .decor-back');
        const backgroundMask = document.querySelector('.background-wrapper-mask');
        const content = document.querySelector('.section-hero .section-content');

        let navbarLogoW = 0,
            navbarLogoH = 0,
            introLogoW = 0,
            introLogoH = 0,
            scaleXVal = 0,
            scaleYVal = 0;

        function updateProperties() {
            navbarLogoW = logo.getBoundingClientRect().width;
            navbarLogoH = logo.getBoundingClientRect().height;
            introLogoW = introLogoBox.getBoundingClientRect().width;
            introLogoH = introLogoBox.getBoundingClientRect().height;
            scaleXVal = navbarLogoW / introLogoW;
            scaleYVal = navbarLogoH / introLogoH;
        }

        window.onload = function () {
            if (localStorage.getItem('hasCodeRunBefore') === null) {
                imagesLoaded(document.body, init)
                localStorage.setItem('hasCodeRunBefore', true);
            } else {
                document.body.classList.remove('has-intro')
            }
        };

        function init() {
            installMediaQueryWatcher('(min-width: 768px)', function (matches) {
                let tl;

                tl = typeof tl === 'object' ? tl.kill() : gsap.timeline();

                updateProperties()

                // Set properties
                tl.set(introLogoBox, {
                    x: '-50%',
                    y: '-50%',
                    top: '50%',
                    left: '50%',
                    opacity: 0,
                }).set(content, {
                    xPercent: 100,
                }).set(decorFront, {
                    opacity: 0,
                }).set(decorBack, {
                    opacity: 0,
                });

                if (matches) {
                    tl.to(introLogoBox, {
                        duration: 1,
                        opacity: 1,
                    }).to(introCurtains, { // Start curtain animation
                        duration: 2,
                        stagger: 0.2,
                        y: 0,
                        ease: Expo.easeOut,
                    }).to(introLogoBox, { // Shrink logo into position
                        duration: 2,
                        x: 0,
                        y: 0,
                        top: 0,
                        left: 0,
                        scaleX: scaleXVal,
                        scaleY: scaleYVal,
                        ease: Expo.easeOut,
                    }).to(logo, { // Show navbar logo
                        opacity: 1
                    }).to(introLogoBox, { // Hide intro logo
                        opacity: 0
                    }).to(navLinks, { // Slide in navbar links
                        duration: 1,
                        stagger: 0.2,
                        opacity: 1,
                        x: 0,
                        ease: Expo.easeOut,
                    }, '<-1').to(intro, { // Hide intro
                        duration: 2,
                        opacity: 0,
                        ease: Expo.easeOut,
                        onComplete: function () {
                            tl.to(intro, {
                                display: 'none'
                            })
                        }
                    }, '>-1').to(content, { // Hide intro
                        duration: 1,
                        xPercent: 0,
                        ease: Expo.easeOut,
                    }, '>-1').to(decorFront, { // Hide intro
                        duration: 0.2,
                        opacity: 1,
                    }).to(decorBack, { // Hide intro
                        duration: 0.2,
                        opacity: 1,
                    }).to(backgroundMask, { // Hide intro
                        duration: 2,
                        width: 0,
                        ease: Expo.easeOut,
                    })
                } else {
                    tl.to(introLogoBox, {
                        duration: 1,
                        opacity: 1,
                    }).to(introCurtains, { // Start curtain animation
                        duration: 2,
                        stagger: 0.2,
                        y: 0,
                        ease: Expo.easeOut,
                    }).to(introLogoBox, { // Shrink logo into position
                        duration: 2,
                        x: 0,
                        y: 0,
                        top: 0,
                        left: 0,
                        scaleX: scaleXVal,
                        scaleY: scaleYVal,
                        ease: Expo.easeOut,
                    }).to(logo, { // Show navbar logo
                        opacity: 1
                    }).to(introLogoBox, { // Hide intro logo
                        opacity: 0
                    }).to(intro, { // Hide intro
                        duration: 2,
                        opacity: 0,
                        ease: Expo.easeOut,
                        onComplete: function () {
                            tl.to(intro, {
                                display: 'none'
                            })
                        }
                    }, '>-1').to(content, { // Hide intro
                        duration: 1,
                        xPercent: 0,
                        ease: Expo.easeOut,
                    }, '>-1').to(decorFront, { // Hide intro
                        duration: 0.2,
                        opacity: 1,
                    }).to(decorBack, { // Hide intro
                        duration: 0.2,
                        opacity: 1,
                    }).to(backgroundMask, { // Hide intro
                        duration: 2,
                        width: 0,
                        ease: Expo.easeOut,
                    })
                }
            });
        }
    }

})();

// Mobile menu
(function () {
    const toggler = document.querySelector('.navbar-menu-toggler'),
        menu = document.querySelector('.navbar-menu'),
        body = document.body;

    let a, b;

    function toggleMenu() {
        var that = this;

        clearTimeout(b);

        if (!menu.classList.contains('menu-open')) {
            body.classList.add('menu-is-open');
            menu.style.display = 'flex';
            setTimeout(function () {
                menu.classList.add('menu-open');
            }, 50);
        } else {
            body.classList.remove('menu-is-open');
            menu.classList.remove('menu-open');
            b = setTimeout(function () {
                menu.style.display = '';
            }, 650);
        }
    }

    if (toggler) {
        toggler.addEventListener('click', toggleMenu, false);
    }
})();

// Load single div backgrounds
(function () {
    var image = document.querySelectorAll('img[data-bg="true"], [data-bg="true"]');

    for (var i = 0; i < image.length; i++) {
        (function (n) {
            var img = new Image();

            img.onload = imageFound;
            img.onerror = imageNotFound;
            img.src = image[n].src;

            function imageFound() {
                image[n].parentNode.style.backgroundImage = 'url(' + img.src + ')';

                if ($(image[n]).parent().is('.bg')) {
                    $(image[n]).parent().css({
                        opacity: '1'
                    });
                }
            }

            function imageNotFound() {
                image[n].parentNode.style.backgroundColor = '#F8F9FD';
            }
        }(i));
    }
})();

// Reveal on scroll
(function () {
    const options = {
        threshold: 0.1,
        rootMargin: '0px 0px 0px 0px',
    };

    var elementsArr = [
        'header',
        '.how-it-works .card',
        '.phone',
        '.section-heading h1',
        '.section-heading h2',
        '.section-heading h6',
        '.section-heading svg',
        '.section-heading p',
        '.section-grid-content > h1',
        '.section-grid-content > h2',
        '.section-grid-content > p',
        '.content-row',
        '.download',
        '.swiper-content',
        '.weezy-map',
        '.shelf-list > li',
        '.press-card',
        '.hero-content h1',
        '.hero-content p',
        '.location-badge',
        '.weezy-bag',
        '.join-weezy-card .bag',
        '.join-weezy-card .btn',
        '.hero-content form',
        '.instagram-grid-item',
        '#section-where-we-deliver form'
    ]

    let itemDelay = .2;

    function onEntry(entry) {

        let itemLoad = 0;

        entry.forEach((change, i) => {

            if (change.isIntersecting) {

                itemLoad++;

                new TimelineMax({})
                    .to(change.target, {
                        opacity: 1,
                        translateY: 0,
                        ease: Expo.easeOut,
                        duration: 2,
                        // delay: i - i * 0.96,
                        delay: itemLoad * itemDelay,
                    }).call(function () {
                    observer.unobserve(change.target);

                    change.target.style.transform = '';
                    change.target.style.opacity = '';
                    change.target.style.willChange = '';
                });

            }
        });
    }

    // // instantiate a new Intersection Observer
    // let observer = new IntersectionObserver(onEntry, options);
    //
    // // list of cards
    // let elements = document.querySelectorAll(elementsArr);
    //
    // const setProperties = e => {
    //     e.style.transform = 'translate3d(0, 2rem, 0)';
    //     e.style.opacity = '0';
    //     e.style.willChange = 'transform, opacity';
    // }
    //
    // elements.forEach(elm => setProperties(elm))
    //
    // // loop through all elements
    // // pass each element to observe method
    // for (let elm of elements) {
    //     observer.observe(elm);
    // }
})();

// Swiper - Gallery
(function () {
    const interleaveOffset = 0.5;

    const swiper = new Swiper('.swiper-gallery', {
        speed: 1200,
        slidesPerView: 1,
        noSwipingClass: '.swiper-gallery',
        watchSlidesProgress: true,
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: '.swiper-gallery .swiper-arrow-next',
            prevEl: '.swiper-gallery .swiper-arrow-prev',
        },
        pagination: {
            el: '.swiper-gallery .swiper-pagination',
            clickable: true,
        },
        on: {
            progress: function () {
                let swiper = this;

                for (var i = 0; i < swiper.slides.length; i++) {
                    var slideProgress = swiper.slides[i].progress;
                    var innerOffset = swiper.width * interleaveOffset;
                    var innerTranslate = slideProgress * innerOffset;
                    swiper.slides[i].querySelector('.project-gallery-photo').style.transform = 'translate3d(' + innerTranslate + 'px, 0, 0)';
                }
            },
            setTransition: function (s, transition) {
                let swiper = this;

                for (var i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].querySelector('.project-gallery-photo').style.transition = `transform ${transition}ms ease`;
                }
            },
            slideChangeTransitionStart: function (swiper) {
                swiper.slides[swiper.realIndex].querySelector('.project-gallery-photo').style.transformOrigin = '0% 50% 0';
                swiper.slides[swiper.previousIndex].querySelector('.project-gallery-photo').style.transformOrigin = '100% 50% 0';
            },
        }
    });
})();

// Swiper - Small quotes
(function () {
    const swiper = new Swiper('.swiper-small-quotes', {
        speed: 1200,
        slidesPerView: 1,
        spaceBetween: 40,
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: '.swiper-small-quotes .swiper-arrow-next',
            prevEl: '.swiper-small-quotes .swiper-arrow-prev',
        },
        pagination: {
            el: '.swiper-small-quotes .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            1280: {
                slidesPerView: 2,
            },
            1440: {
                slidesPerView: 3,
            }
        }
    });
})();

// Swiper - Projects
(function () {
    const swiper = new Swiper('.swiper-projects', {
        speed: 1200,
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: '.swiper-projects .swiper-arrow-next',
            prevEl: '.swiper-projects .swiper-arrow-prev',
        },
        pagination: {
            el: '.swiper-projects .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            500: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 2,
            },
            1440: {
                slidesPerView: 3,
            }
        }
    });
})();

// Collapsible
(function () {
    let opened = null
    let a

    const toggleVisibility = e => {
        e.classList.toggle('open')

        clearTimeout(a);

        if (e.classList.contains('open')) {
            e.style.display = 'block'
            e.style.maxHeight = e.scrollHeight + 'px'
        } else {
            e.style.maxHeight = ''
            a = setTimeout(function () {
                e.style.display = ''
            }, 600);
        }
    }

    const handleAccordion = e => {

        const clickedItem = e.parentElement.children[0].nextElementSibling

        toggleVisibility(clickedItem)

        if (!opened) {
            opened = clickedItem
        } else if (opened == clickedItem) {
            opened = null
        } else {
            toggleVisibility(opened)
            opened = clickedItem
        }

    }

    const handleClick = e => {
        if (e.target.dataset.collapsible) {
            e.preventDefault();

            handleAccordion(e.target)
        }

    }

    document.addEventListener('click', handleClick)
})();

// Tabs
(function () {
    function hasClass(element, className) {
        return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
    }

    function removeClassPrefix(element, prefix) {
        const classes = element.className.split(' ').filter(c => !c.startsWith(prefix));
        element.className = classes.join(' ').trim();
    }

    const toggleVisibility = e => {
        const tabTarget = e
        const paneTarget = document.querySelector(e.hash)
        const previousActiveTab = document.querySelector('.nav-link[data-tab].active')
        const previousActivePane = document.querySelector('.tab-pane.active')

        // handle current active tab
        tabTarget.classList.add('active')
        // handle previously active tab
        previousActiveTab.classList.remove('active')
        // handle previously active pane
        previousActivePane.classList.remove('show')
        setTimeout(function () {
            previousActivePane.classList.remove('active')
            // handle current active pane
            paneTarget.classList.add('active')
            setTimeout(function () {
                paneTarget.classList.add('show')
            }, 10)
        }, 150)
    }

    const updateSketchLines = e => {
        const decor = document.querySelector('.how-section .decor')
        const classes = ['nav-blue', 'nav-yellow', 'nav-pink', 'nav-black']

        removeClassPrefix(decor, 'nav');

        for (let i = 0; i < classes.length; i++) {
            if (hasClass(e.parentNode, classes[i])) {
                decor.classList.add(classes[i])
            }
        }
    }

    const handleTabs = e => {

        const clickedItem = e

        if (!clickedItem.matches('.active')) {
            toggleVisibility(clickedItem)
            updateSketchLines(clickedItem)
        }

    }

    const handleClick = e => {
        if (e.target.dataset.tab) {
            e.preventDefault();

            handleTabs(e.target)
        }

    }

    document.addEventListener('click', handleClick)
})();
